import React from 'react';
import {connect} from 'react-redux';
import clx from 'classnames';
import {defineMessages, FormattedMessage} from 'react-intl';

import _ from 'underscore';

import {
    toggleOneClickMode as toggleOneClickModeAction,
    setOneClickAmount as setOneClickAmountAction,
    toggleAcceptFactorIncrease as toggleAcceptFactorIncreaseAction,
    toggleAcceptFactorDecrease as toggleAcceptFactorDecreaseAction,
    setFavouriteBetAmount as setFavouriteBetAmountAction
} from 'actions/creators/BettingMode';

import * as AcceptFactorChangeMode from 'constants/AcceptFactorChange';
import * as resources from 'constants/accountResourceNames';
import { minAmount } from 'constants/StakeMinAmount';
import { maxAmount } from 'constants/StakeMaxAmount';

const messages = defineMessages({
    title: {
        id: 'coupon.menu.title',
        defaultMessage: 'Меню ставок'
    },
    oneClickCheckBox: {
        id: 'coupon.menu.one-click_checkbox',
        defaultMessage: 'Ставка в один клик'
    },
    oneClickAmount: {
        id: 'coupon.menu.one-click_amount',
        defaultMessage: 'Сумма ставки '
    },
    acceptFactorIncrease: {
        id: 'coupon.menu.accept_factor_increase',
        defaultMessage: 'Согласен на повышение коэффициента'
    },
    acceptFactorDecrease: {
        id: 'coupon.menu.accept_factor_decrease',
        defaultMessage: 'Согласен на понижение коэффициента'
    },
    favouriteBets: {
        id: 'coupon.menu.favouriteBets',
        defaultMessage: 'Любимые ставки'
    },
    favouriteBet: {
        id: 'coupon.menu.favouriteBet',
        defaultMessage: 'Ставка {num} '
    }
});

export const STAKES_VALUES = {
    UZ: [5000, 10000, 50000, 1000000],
    KZ: [50, 50, 100, 200],
    KG: [50, 50, 100, 200],
}

class CouponDropDownMenu extends React.Component {
    static propTypes = {
        bettingMode: React.PropTypes.object.isRequired,
        user: React.PropTypes.any,
        onClosing: React.PropTypes.func.isRequired,
        toggleOneClickModeAction: React.PropTypes.func.isRequired,
        setOneClickAmountAction: React.PropTypes.func.isRequired,
        toggleAcceptFactorIncreaseAction: React.PropTypes.func.isRequired,
        toggleAcceptFactorDecreaseAction: React.PropTypes.func.isRequired,
        setFavouriteBetAmountAction: React.PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);

        this.state = {
            isOneClickOn: undefined,
            acceptFactorIncrease: undefined,
            acceptFactorDecrease: undefined,
            oneClickAmount: undefined,
            favouriteBet1Amount: undefined,
            favouriteBet2Amount: undefined,
            favouriteBet3Amount: undefined
        };

        this._isInsidePopup = this._isInsidePopup.bind(this);
        this._onDocumentClick = this._onDocumentClick.bind(this);

        document.addEventListener('click', this._onDocumentClick);

        this._handleOneClickModeClick = this._handleOneClickModeClick.bind(this);

        this._onOneClickModeChanged = _.debounce(() => {
            this.props.toggleOneClickModeAction();
        }, 50);

        this._onOneClickAmountChanged = _.debounce((value) => {
            this.props.setOneClickAmountAction(value);
        }, 50);

        this._onAcceptFactorIncreaseChanged = _.debounce((value) => {
            this.props.toggleAcceptFactorIncreaseAction(value);
        }, 50);

        this._onAcceptFactorDecreaseChanged = _.debounce((value) => {
            this.props.toggleAcceptFactorDecreaseAction(value);
        }, 50);

        this._onFavouriteAmountChanged = _.debounce((number, value) => {
            this.props.setFavouriteBetAmountAction({number, amount: value});
        }, 50);
    }

    componentWillMount() {
        const {bettingMode, countryCode} = this.props
        const values = STAKES_VALUES[countryCode]
        const oneClickAmount = bettingMode.get('oneClickAmount') || values[0];
        const favouriteBet1Amount = bettingMode.get('favouriteBet1Amount') || values[1];
        const favouriteBet2Amount = bettingMode.get('favouriteBet2Amount') || values[2];
        const favouriteBet3Amount = bettingMode.get('favouriteBet3Amount') || values[3];
        const isOneClickOn = bettingMode.get('isOneClick') || false;
        const acceptFactorChange = bettingMode.get('acceptFactorChange') || AcceptFactorChangeMode.NONE;

        const acceptFactorIncrease = acceptFactorChange === AcceptFactorChangeMode.INCREASE ||
            acceptFactorChange === AcceptFactorChangeMode.BOTH;
        const acceptFactorDecrease = acceptFactorChange === AcceptFactorChangeMode.DECREASE ||
            acceptFactorChange === AcceptFactorChangeMode.BOTH;

        this.setState({
            oneClickAmount,
            favouriteBet1Amount,
            favouriteBet2Amount,
            favouriteBet3Amount,
            isOneClickOn,
            acceptFactorIncrease,
            acceptFactorDecrease
        });
    }

    shouldComponentUpdate(nextProps, nextState) {
        return this.props.bettingMode !== nextProps.bettingMode ||
            this.props.user !== nextProps.user ||
            this.state !== nextState;
    }

    componentWillUnmount() {
        document.removeEventListener('click', this._onDocumentClick);
    }

    _isInsidePopup(element) {
        if (element === null) {
            return false;
        }

        if (element === this.refs.popup) {
            return true;
        }

        return this._isInsidePopup(element.parentElement);
    }

    _onDocumentClick(e) {
        if (this._isInsidePopup(e.target)) {
            return;
        }

        document.removeEventListener('click', this._onDocumentClick);

        this.props.onClosing();
    }

    _handleOneClickModeClick(e) {
        e.preventDefault();
        const value = !this.state.isOneClickOn;

        this.setState(Object.assign({}, this.state, {
            isOneClickOn: value
        }));

        this._onOneClickModeChanged();
    }

    _handleOneClickAmountChange(e) {
        e.preventDefault();
        const value = parseInt(e.target.value);

        this.setState(Object.assign({}, this.state, {
            oneClickAmount: value
        }));

        this._onOneClickAmountChanged(value);
    }

    _handleAcceptFactorIncrease(val, e) {
        e.preventDefault();

        const state = this.state;
        this.setState({
            ...state,
            acceptFactorIncrease: val
        });

        this._onAcceptFactorIncreaseChanged(val);
    }

    _handleAcceptFactorDecrease(val, e) {
        e.preventDefault();

        this.setState(Object.assign({}, this.state, {
            acceptFactorDecrease: val
        }));

        this._onAcceptFactorDecreaseChanged(val);
    }

    _handleFavouriteAmountChange = number => e => {
        e.preventDefault();
        const value = parseInt(e.target.value);

        if (number === 1) {
            this.setState({
                favouriteBet1Amount: value
            });
        } else if (number === 2) {
            this.setState({
                favouriteBet2Amount: value
            });
        } else if (number === 3) {
            this.setState({
                favouriteBet3Amount: value
            });
        }

        this._onFavouriteAmountChanged(number, value);
    }

    render() {
        const {user} = this.props;

        let resourceId;
        let currency;
        let minStakeAmount = 0;
        let maxStakeAmount = 0;

        if (user) {
            resourceId = user.get('resourceId');
            currency = resources.resourceNames[resourceId];
            minStakeAmount = minAmount[currency]
            maxStakeAmount = maxAmount[currency]
        }

        const acceptIncrease = this.state.acceptFactorIncrease;
        const acceptDecrease = this.state.acceptFactorDecrease;

        const oneClick = this.state.isOneClickOn;

        const oneClickAmount = this.state.oneClickAmount || 0;
        const favouriteBet1Amount = this.state.favouriteBet1Amount || 0;
        const favouriteBet2Amount = this.state.favouriteBet2Amount || 0;
        const favouriteBet3Amount = this.state.favouriteBet3Amount || 0;

        const boundAcceptIncreaseClick = this._handleAcceptFactorIncrease.bind(this, !acceptIncrease);
        const boundAcceptDecreaseClick = this._handleAcceptFactorDecrease.bind(this, !acceptDecrease);

        const boundOneClickAmountChange = this._handleOneClickAmountChange.bind(this);

        return (
            <ul ref="popup" className="dropdown--menu dropdown--menu-coupon  dropdown--menu__shown">
                <li className="title dropdown--menu__title dropdown--menu__item">
                        <span className="dropdown--menu__span">
                            <FormattedMessage {...messages.title}/>
                        </span>
                </li>
                <li className="dropdown--menu__item">
                    <div className="dropdown--menu-coupon__block" onClick={this._handleOneClickModeClick}>
                        <input className="checkbox--list__checkbox"
                               type="checkbox"
                               checked={oneClick}
                               onChange={this._handleOneClickModeClick}/>
                        <label className="checkbox--list__label checkbox--list__label__js">
                            <FormattedMessage {...messages.oneClickCheckBox}/>
                        </label>
                    </div>
                    <div className="dropdown--menu-coupon__block">
                            <span className="dropdown--menu-coupon__span">
                                <FormattedMessage {...messages.oneClickAmount}/>
                            </span>
                        <input className={clx('dropdown--menu-coupon__input', {error: isMinAndMaxValueWrong(minStakeAmount, maxStakeAmount, oneClickAmount)})} 
                               pattern="[0-9]*"
                               maxLength="7"
                               value={oneClickAmount}
                               onChange={boundOneClickAmountChange}
                               onBlur={boundOneClickAmountChange}/>
                        <label className="dropdown--menu-coupon__input__label">
                            {currency}
                        </label>
                    </div>
                </li>
                <li className="dropdown--menu__item">
                    <div className="dropdown--menu-coupon__block" onClick={boundAcceptIncreaseClick}>
                        <input className="checkbox--list__checkbox"
                               type="checkbox"
                               checked={acceptIncrease}
                               onChange={boundAcceptIncreaseClick}/>
                        <label className="checkbox--list__label checkbox--list__label__js">
                            <FormattedMessage {...messages.acceptFactorIncrease}/>
                        </label>
                    </div>
                </li>
                <li className="dropdown--menu__item">
                    <div className="dropdown--menu-coupon__block" onClick={boundAcceptDecreaseClick}>
                        <input className="checkbox--list__checkbox"
                               type="checkbox"
                               checked={acceptDecrease}
                               onChange={boundAcceptDecreaseClick}/>
                        <label className="checkbox--list__label checkbox--list__label__js">
                            <FormattedMessage {...messages.acceptFactorDecrease}/>
                        </label>
                    </div>
                </li>
                <li className="dropdown--menu__item dropdown--menu__item__favourites">
                    <div className="dropdown--menu-coupon__block__favourites dropdown--menu-coupon__block">
                        <label className="dropdown--menu-coupon__input__label">
                            <FormattedMessage {...messages.favouriteBets}/>
                        </label>
                    </div>
                    <div className="dropdown--menu-coupon__block">
                            <span className="dropdown--menu-coupon__span">
                                <FormattedMessage {...messages.favouriteBet} values={{num: 1}}/>
                            </span>
                        <input className={clx('dropdown--menu-coupon__input', {error: isMinAndMaxValueWrong(minStakeAmount, maxStakeAmount, favouriteBet1Amount)})}
                               value={favouriteBet1Amount}
                               onChange={this._handleFavouriteAmountChange(1)}
                               onBlur={this._handleFavouriteAmountChange(1)}/>
                        <label className="dropdown--menu-coupon__input__label">
                            {currency}
                        </label>
                    </div>
                    <div className="dropdown--menu-coupon__block">
                              <span className="dropdown--menu-coupon__span">
                                <FormattedMessage {...messages.favouriteBet} values={{num: 2}}/>
                              </span>
                        <input className={clx('dropdown--menu-coupon__input', {error: isMinAndMaxValueWrong(minStakeAmount, maxStakeAmount, favouriteBet2Amount)})}
                               value={favouriteBet2Amount}
                               onChange={this._handleFavouriteAmountChange(2)}
                               onBlur={this._handleFavouriteAmountChange(2)}/>
                        <label className="dropdown--menu-coupon__input__label">
                            {currency}
                        </label>
                    </div>
                    <div className="dropdown--menu-coupon__block">
                        <span className="dropdown--menu-coupon__span">
                                <FormattedMessage {...messages.favouriteBet} values={{num: 3}}/>
                              </span>
                        <input className={clx('dropdown--menu-coupon__input', {error: isMinAndMaxValueWrong(minStakeAmount, maxStakeAmount, favouriteBet3Amount)})}
                               value={favouriteBet3Amount}
                               onChange={this._handleFavouriteAmountChange(3)}
                               onBlur={this._handleFavouriteAmountChange(3)}/>
                        <label className="dropdown--menu-coupon__input__label">
                            {currency}
                        </label>
                    </div>
                </li>
            </ul>
        );
    }
}

export function isMinAndMaxValueWrong (min = 0, max = 99999999, value) {
    if(value < min || value > max) {
        return true
    }
    return false
}

function select(state, props) {
    const bettingMode = props.bettingMode;
    const user = props.user;

    return {
        countryCode: state.application.get('countryCode'),
        bettingMode,
        user,
    };
}

export default connect(select, {
    toggleOneClickModeAction,
    setOneClickAmountAction,
    toggleAcceptFactorIncreaseAction,
    toggleAcceptFactorDecreaseAction,
    setFavouriteBetAmountAction
})(CouponDropDownMenu);



// WEBPACK FOOTER //
// ./js/sport-betting/components/bet-panel-control/CouponDropDownMenu.jsx